/*
 * @Description:
 * @version:
 * @Author: sunqian_sr
 * @Date: 2022-11-17 17:01:45
 * @LastEditors: Andy
 * @LastEditTime: 2023-01-11 14:06:36
 */
import { Message } from 'element-ui'

const errorCodeConfig = {
  400: '错误的请求',
  401: '未授权，请登录',
  403: '权限不足',
  404: '资源不存在',
  405: '不允许的方法',
  500: '内部服务错误',
  10004: '用户登录信息错误'
  //   503: '服务不可用，服务器暂时过载或维护',
  //   504: '网关超时'
}
const errorCodes = Object.keys(errorCodeConfig).map((item) => Number(item))
export const handleErrorHttpCode = (status, msg) => {
  // 状态码判断
  if (!errorCodes.includes(status)) {
    Message({
      message: msg || `其他错误, 代码${status}`,
      type: 'error'
    })
    return false
  }
  // 调用者未配置手动处理以上错误时 弹窗提示错误
  Message({
    message: `${errorCodeConfig[status]}, 代码${status}`,
    type: 'error'
  })
  return false
}
